<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner clearfix">
      <div class="indexworkleft fl">
        <taskleft></taskleft>
      </div>
      <div class="indexworkright fr">
        <taskright></taskright>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/work.css";
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import Taskleft from "../../components/work/taskleft.vue";
import Taskright from "../../components/task/taskright.vue";

export default {
  name: "issuework",
  data() {
    return {};
  },
  components: {
    Taskleft,
    Taskright,
    top,
    navMenu,
  },
  mounted() {
    // console.log("121");
  },
  methods: {},
};
</script> 
<style scoped>
.indexworkleft {
  background: none;
  padding: 0 10px 0 0;
}
body,
html,
div,
blockquote,
img,
label,
p,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
ul,
ol,
li,
dl,
dt,
dd,
form,
a,
fieldset,
input,
th,
td,
i,
em {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.inner {
  margin-top: 15px;
}
</style>